var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c("div", { staticClass: "relative-position loader" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "q-card",
              {
                staticClass: "md-card q-mt-lg q-pa-lg relative-position",
                attrs: { color: "white", "text-color": "black" }
              },
              [
                _c("q-card-title", [
                  _vm._v(
                    "\n                    Helpful Links for Quickbooks\n                    "
                  ),
                  _c(
                    "span",
                    { attrs: { slot: "subtitle" }, slot: "subtitle" },
                    [
                      _vm._v(
                        "Payment service is provided by Intuit Payments Inc"
                      )
                    ]
                  )
                ]),
                _c("q-card-separator"),
                _c(
                  "q-card-main",
                  [
                    _c(
                      "q-list",
                      { attrs: { highlight: "" } },
                      [
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-side",
                              [
                                _c("q-item-tile", {
                                  attrs: { icon: "link", color: "primary" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: { flat: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openLink(
                                          "https://qbo.intuit.com"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" Quickbooks Online")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-side",
                              [
                                _c("q-item-tile", {
                                  attrs: { icon: "link", color: "primary" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: { flat: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openLink(
                                          _vm.merchantCenterUrl
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" Merchant Terminal Home")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-side",
                              [
                                _c("q-item-tile", {
                                  attrs: { icon: "link", color: "primary" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: { flat: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openLink(
                                          "https://merchantcenter.intuit.com/msc/portal/reporting"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" Merchant Transactions")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-side",
                              [
                                _c("q-item-tile", {
                                  attrs: { icon: "link", color: "primary" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: { flat: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openLink(
                                          "https://merchantcenter.intuit.com/msc/portal/tpc/cc"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" Merchant Charge a Card")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-side",
                              [
                                _c("q-item-tile", {
                                  attrs: { icon: "link", color: "primary" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: { flat: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openLink(
                                          "https://merchantcenter.intuit.com/portal/authsec/portal/qbms/Manage+merchant+account/View+and+Download+Statements"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(" Merchant Statements")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-side",
                              [
                                _c("q-item-tile", {
                                  attrs: { icon: "link", color: "primary" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: { flat: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openLink(
                                          _vm.quickbooksConnectUrl
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " Reconnect AGC Application to Quickbooks"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }